import { render, staticRenderFns } from "./ScheduleMeal.vue?vue&type=template&id=47d989a7"
import script from "./ScheduleMeal.vue?vue&type=script&lang=js"
export * from "./ScheduleMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports